/*
 * ProcessImagesAndDefinitions.js
 *
 * Author: Kevin Dench <kevin.dench@intellidata.net>
 * Author: IntelliData, Inc.
 * License: Proprietary
 * Version: 1.0
 * Copyright: 2016.
 */

/* @ngInject */
export default function ImageProcessorService() {
    const host = 'search.kemet.com';
    const protocol = 'https';

    return {
        getImage: function (definitionImage) {
            const img = {};
            if (definitionImage != null) {
                img.src = definitionImage.url;
                img.alt = definitionImage.alt;
                img.title = definitionImage.title;
            }
            return img;
        },
        processImagesAndDefinitions: function (series, definitions) {
            if (definitions !== undefined) {
                if (definitions.childDefinitions) {
                    this.processImagesAndDefinitions(series, definitions.childDefinitions);
                } else {
                    for (let j = 0; j < definitions.length; j++) {
                        if (typeof(definitions[j]) !== 'undefined') {
                            if (typeof(definitions[j].childDefinitions) !== 'undefined' && definitions[j].childDefinitions.length > 0) {
                                this.processImagesAndDefinitions(series, definitions[j].childDefinitions);
                            }

                            if (definitions[j].definitionImage != null) {
                                definitions[j].img = {};
                                definitions[j].img.src = definitions[j].definitionImage.url;
                                definitions[j].img.alt = definitions[j].definitionImage.alt;
                                definitions[j].img.title = definitions[j].definitionImage.title;

                                if (series != null && definitions[j].seriesImages != null) {
                                    for (let k = 0; k < definitions[j].seriesImages.length; k++) {
                                        if (series.id === definitions[j].seriesImages[k].seriesParameterValue.id) {
                                            definitions[j].img.src = definitions[j].seriesImages[k].url;
                                            definitions[j].img.alt = definitions[j].seriesImages[k].alt;
                                            definitions[j].img.title = definitions[j].seriesImages[k].title;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
            }
            return definitions;
        },
        // Private accessors
        // ========================
        buildImageUrl: function (path, file) {
            return path + '/' + file;
        },
        getDomain: function () {
            return protocol + '://' + host;
        }
    };
}
